import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/guard/auth/auth.guard';

const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'user/user-management',
    pathMatch: 'full'
  },
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    loadChildren: () => import('./components/components.module').then((m) => {
      return new Promise(resolve => setTimeout(() => resolve(m.ComponentsModule), 1500));
    }),
  }
]

const routerOptions: ExtraOptions = {
	scrollPositionRestoration: "enabled",
	anchorScrolling: "enabled",
	scrollOffset: [0, 64],
	onSameUrlNavigation: "reload",
};


@NgModule({
  imports: [RouterModule.forRoot(appRoutes, routerOptions)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
